import BaseCustomScheme from './baseCustomScheme'

export default class Scheme2fa extends BaseCustomScheme {
  // you can extend functionality of this schema later
}
